<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Сотрудник: {{ user.client_name }}</h2>
        <el-tabs ref="tabs">
          <el-tab-pane label="Информация">
            <el-form
              class="page__form"
              id="formEditClient"
              :model="form"
              ref="form"
              :rules="rules"
              label-position="right"
              label-width="180px"
            >
              <el-form-item label="Имя" prop="client_name">
                <el-input
                  id="client_name"
                  size="small"
                  v-model="form.client_name"
                  :readonly="!$can('update', 'employees')"
                />
              </el-form-item>
              <el-form-item label="Email" prop="email">
                <span slot="label">Email <br/> (Логин для авторизации)</span>
                <el-input id="email" size="small" v-model="form.email" :readonly="!$can('update', 'employees')" />
              </el-form-item>
              <el-form-item label="Уведомления" prop="email_notification">
                <el-switch
                  id="notification"
                  size="small"
                  :active-value="1"
                  :inactive-value="0"
                  v-model="form.email_notification"
                  :disabled="!$can('update', 'employees')"
                />
              </el-form-item>
              <el-form-item v-if="$can('update', 'employees')" label="Пароль" prop="password">
                <el-button id="changePassword" @click="dialog = true" type="danger" size="small">Изменить</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </main>
    <el-dialog id="dialogPassword" title="Изменить пароль" :visible.sync="dialog">
      <el-form
        id="formPassword"
        :model="formPassword"
        ref="formPassword"
        :rules="rulesPassword"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="Новый пароль" prop="password">
          <el-input id="password" v-model="formPassword.password" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button id="closeDialog" @click="dialog = false">Отменить</el-button>
        <el-button id="savePassword" type="primary" @click="savePassword">Изменить</el-button>
      </span>
    </el-dialog>
    <el-footer v-if="showManageFooter" class="page__active_bar">
      <el-button
        v-if="$can('update', 'employees')"
        class="page__active_button"
        id="submit"
        type="primary"
        @click="submit"
        >Сохранить</el-button
      >
      <el-button
        v-if="$can('delete', 'employees')"
        class="page__active_button"
        id="delete"
        type="danger"
        @click="removeUser"
        >Удалить</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { required, length, validatorAllLatine, validatorSpace } from "@/core/helpers/validators";
import mapKey from "@/core/helpers/mapKey";

export default {
  name: "FormUser",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      form: {
        client_name: "",
        email: "",
        email_notification: 0,
      },
      rules: this.$can("update", "employees")
        ? {
            client_name: [required(), length(4, 100)],
            email: [required()],
          }
        : null,
      formPassword: {
        password: "",
      },
      rulesPassword: {
        password: [required(), length(4, 100), validatorSpace, validatorAllLatine],
      },
      currentName: "0",
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    showManageFooter() {
      return this.$can("update", "employees") || this.$can("delete", "employees");
    },
  },
  watch: {
    user(newUser) {
      mapKey(this.form, newUser);
    },
  },
  created() {
    this.getUser(this.id);
  },
  methods: {
    ...mapActions("user", {
      updateUser: "UPDATE_USER",
      getUser: "GET_USER",
      deleteUser: "DELETE_USER",
    }),
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.updateUser({
            id: this.id,
            user: this.form,
          })
            .then(() => {
              this.$message({
                message: "Информация обновлена",
                type: "success",
              });
            })
            .catch((err) => {
              const { error } = err.response.data;
              this.$message({
                dangerouslyUseHTMLString: true,
                showClose: true,
                message: `При редактировании клиента произошла ошибка. </br></br> <b>${error}</b>`,
                type: "error",
              });
            });
        }
        return valid;
      });
    },
    removeUser() {
      this.$confirm("Вы точно хотите удалить сотрудника?", "Удаление", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отмена",
        type: "warning",
      }).then(() => {
        this.deleteUser(this.id).then(() => {
          this.$message({
            message: "Сотрудник удален",
            type: "success",
          });
          window.history.back();
        });
      });
    },
    savePassword() {
      this.dialog = false;
      this.$set(this.form, "password", this.formPassword.password);
    },
  },
};
</script>
